import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  usersList: [],
  userById: {},
  loading : { 
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
  },
  error: false,
  errorMessage: "",
};

const userSlice = createSlice({
  name: "userManagement",
  initialState,
  reducers: {
    getUsersList(state, action) {
      state.usersList = action.payload;
      state.loading.read = false;
      state.error = false;
    },
    userByIdData(state, action) {
      state.userById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getUsersList,
  userByIdData,
  errorMessages,
  setLoading,
  hideErrorMessage,
} = userSlice.actions;

export default userSlice.reducer;
